import { IResourceMetadata } from '../http/IResourceMetadata';
import { MediaTypeDetector } from "@colibrio/colibrio-reader-framework/colibrio-core-io-mediatypedetector";
import { AwsHttpRequest } from "./AwsHttpRequest";

export class AwsSignedUrlHttpHeaderReader {
    static async fromUrl(url: string): Promise<IResourceMetadata> {
        
        return AwsHttpRequest.sendHeadRequest(url).then(async response => {
            return AwsHttpRequest.sendRangeRequest(url, 0, Math.min(response.contentLength, 16000)).then(buffer => {
                let mediaType = MediaTypeDetector.detectFromUint8Array(new Uint8Array(buffer));
                if (!mediaType) {
                    if (response.contentType) {
                        mediaType = response.contentType;
                    } else {
                        throw new Error('Unable to detect the media-type');
                    }
                }
                return {
                    mediaType: mediaType,
                    size: response.contentLength
                };
            });

        });
    }
}
